<template>
  <v-container fluid class="py-0">
    <div>{{ label }}</div>
    <v-row>
      <v-col v-for="item,i in items" :key="i" cols="12" xs="12" sm="6" md="4">
        <v-checkbox
          class="mt-0"
          v-model="selected"
          :label="trans(item.text, null ,item.text)"
          :value="item.value"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <div v-if="error" class="error--text">
      <small>{{ errorMessages }}</small>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  props: ["label", "items", "value", "error", "error-messages", "id"],

  computed: {
    ...mapGetters("search", {
      filterValue: "filterValue",
    }),
    selected: {
      get: function () {
        return this.$props.value || [];

        // return this.filterValue(this.id) || [];
      },
      set: function (value) {
        console.log("out set", value);

        this.$emit("input", value);
      },
    },
  },
};
</script>